import Swal from "sweetalert2";
import api from "../../services/api";

/**
 * Exportar facturas para el contador
 * Genera un Excel con 2 hojas: Consumidor Final y Crédito Fiscal
 * Con las 28 columnas específicas que el contador necesita
 */
export const exportForAccountant = async (fromDate, toDate) => {
  try {
    // Validar que haya fechas
    if (!fromDate || !toDate) {
      return Swal.fire(
        "Atención",
        "Debes seleccionar un rango de fechas para exportar",
        "warning"
      );
    }

    // Confirmar exportación
    const result = await Swal.fire({
      title: "Exportar para Contador",
      html: `
        <p>Se generará un archivo Excel con:</p>
        <ul style="text-align: left; margin-left: 20px;">
          <li><strong>Hoja 1:</strong> Facturas Consumidor Final (Tipo 01)</li>
          <li><strong>Hoja 2:</strong> Facturas Crédito Fiscal (Tipo 03)</li>
        </ul>
        <p><strong>Período:</strong> ${formatDate(fromDate)} al ${formatDate(toDate)}</p>
        <p>Solo se incluirán facturas VALIDADAS</p>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, exportar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
    });

    if (!result.isConfirmed) return;

    // Mostrar loading
    Swal.fire({
      title: "Generando Excel...",
      text: "Por favor espera mientras se procesa la exportación",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // Llamar al endpoint
    const response = await api.post(
      "/invoices/export-accountant",
      {
        from: fromDate,
        to: toDate,
      },
      {
        responseType: "blob", // Importante para recibir el archivo
      }
    );

    // Crear blob y descargar
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Nombre del archivo con fechas
    const fechaInicio = fromDate.replace(/-/g, "_");
    const fechaFin = toDate.replace(/-/g, "_");
    link.download = `facturas_contador_${fechaInicio}_al_${fechaFin}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    // Cerrar loading y mostrar éxito
    Swal.fire({
      icon: "success",
      title: "¡Exportación Completa!",
      html: `
        <p>El archivo Excel se descargó correctamente</p>
        <p><strong>Archivo:</strong> facturas_contador_${fechaInicio}_al_${fechaFin}.xlsx</p>
        <p style="margin-top: 15px; font-size: 14px; color: #666;">
          El archivo contiene 2 hojas:<br>
          • Consumidor Final<br>
          • Crédito Fiscal
        </p>
      `,
      confirmButtonText: "Entendido",
      timer: 5000,
    });
  } catch (error) {
    console.error("Error exportando para contador:", error);

    let errorMessage = "No se pudo completar la exportación";

    if (error.response) {
      // Error del servidor
      if (error.response.status === 404) {
        errorMessage = "No se encontraron facturas en el rango de fechas seleccionado";
      } else if (error.response.status === 422) {
        errorMessage = "Las fechas proporcionadas no son válidas";
      } else if (error.response.data?.message) {
        errorMessage = error.response.data.message;
      }
    } else if (error.request) {
      // No hay respuesta del servidor
      errorMessage = "No se pudo conectar con el servidor. Verifica tu conexión.";
    }

    Swal.fire({
      icon: "error",
      title: "Error en la Exportación",
      text: errorMessage,
      confirmButtonText: "Entendido",
    });
  }
};

/**
 * Función auxiliar para formatear fechas
 */
const formatDate = (dateString) => {
  if (!dateString) return "";

  const [year, month, day] = dateString.split("-");
  const date = new Date(year, month - 1, day);

  return date.toLocaleDateString("es-SV", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};